// extracted by mini-css-extract-plugin
export default {"patientDashboard":"PatientDashboard_patientDashboard__6Mqkz","contentWrapper":"PatientDashboard_contentWrapper__MXRqv","backgroundImage":"PatientDashboard_backgroundImage__vMg+r"};